var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("img", {
    staticClass: "google-wallet-button",
    attrs: {
      id: _vm.settings.id,
      src: _vm.settings.imgSrc[_vm.$i18n.locale],
      alt: _vm.$t("label.ticketGoogleWallet")
    },
    on: {
      click: function($event) {
        _vm.$emit("start-download", _vm.ticket)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }